import classNames from 'clsx';
import React, { type ReactElement, memo, useCallback } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { DataListControl, EDatalistControlTheme } from 'reactApp/ui/DataListControl/DataListControl';
import type { PublishControlItemProps } from 'reactApp/ui/DataListItem/DataListItem.types';
import { Hint } from 'reactApp/ui/Hint/Hint';

import styles from '../DataListGalleryItem.css';

export const Publish = memo(({ isActive, onClick, isSeoEnabled, showPublicButton, itemId }: PublishControlItemProps): ReactElement => {
    const handleOnPublish = useCallback(
        (e) => {
            onClick(e);
        },
        [onClick]
    );

    return (
        <Hint text="Поделиться ссылкой">
            <div
                className={classNames(styles.control, styles.weblink, {
                    [styles.weblinkForceShow]: showPublicButton,
                })}
                data-item-id={itemId}
            >
                <DataListControl
                    type={isSeoEnabled ? 'seo' : 'publish'}
                    active={isActive}
                    onClick={handleOnPublish}
                    size={28}
                    theme={EDatalistControlTheme.dark}
                    viewType={EViewMode.gallery}
                />
            </div>
        </Hint>
    );
});
Publish.displayName = 'Publish';
